/* Keep Microsoft's conversation UI intact; only replace its floating launcher. */
(function () {
  'use strict';
  if (window.tototoAiHeader) return;
  window.tototoAiHeader = true;
  var root = null;
  var observer = null;
  var frame = 0;
  var wasOpen = false;
  var lastTrigger = null;
  var styleId = 'tototo-ai-header-launcher-style';


  function normalizedText(value) { return value.replace(/\s+/g, ' ').trim(); }
  function dedicatedContainer(element, text) {
    var parent = element.parentElement;
    while (parent && parent.id !== 'root' && parent.getAttribute('role') !== 'dialog' &&
      normalizedText(parent.textContent) === text) {
      element = parent;
      parent = element.parentElement;
    }
    return element;
  }
  function customizeAgentMenu() {
    if (!root) return;
    var customizationStyleId = 'tototo-ai-menu-style';
    if (!root.getElementById(customizationStyleId)) {
      var menuStyle = document.createElement('style');
      menuStyle.id = customizationStyleId;
      menuStyle.textContent =
        '[data-tototo-ai-disclaimer] { display: none !important; }' +
        '@media (max-width: 768px) { [data-tototo-ai-mobile-settings] { display: none !important; } }';
      root.appendChild(menuStyle);
    }
    // Match only the supplied Japanese UI text inside the agent's own shadow root.
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = normalizedText(node.nodeValue);
      var element = node.parentElement;
      if (!element || element.closest('style, script, textarea, [contenteditable="true"]')) return;
      // User/assistant chat messages are content, not menu labels.
      if (element.closest('main, [role="article"], [data-testid^="chat-message-"]')) return;
      if (text === '使用条件') {
        node.nodeValue = node.nodeValue.replace('使用条件', '利用規約');
        var termsLink = element.closest('a, button, [role="link"]');
        if (termsLink && termsLink.getAttribute('aria-label') === '使用条件') {
          termsLink.setAttribute('aria-label', '利用規約');
        }
      }
      if (text === '設定') {
        var settingsRow = element.closest('button, a, [role="button"], [role="menuitem"]');
        if (!settingsRow || normalizedText(settingsRow.textContent) !== '設定') {
          settingsRow = dedicatedContainer(element, '設定');
        }
        settingsRow.setAttribute('data-tototo-ai-mobile-settings', '');
      }
      if (text.indexOf('AI を使用しているため') !== -1 ||
          text.indexOf('間違いを犯すことがあります') !== -1) {
        var candidate = element;
        for (var depth = 0; candidate && depth < 4; depth++, candidate = candidate.parentElement) {
          var noticeText = normalizedText(candidate.textContent);
          if (/^tototo AI は AI を使用しているため、時には間違いを犯すことがあります[。.]?$/.test(noticeText)) {
            dedicatedContainer(candidate, noticeText).setAttribute('data-tototo-ai-disclaimer', '');
            break;
          }
        }
      }
    });
  }

  function buttons() { return document.querySelectorAll('[data-tototo-ai-trigger]'); }
  function launcher() { return root && root.querySelector('[data-testid="entrypoint"] [role="button"]'); }
  function dialog() { return root && root.querySelector('[role="dialog"]'); }
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(function () { frame = 0; sync(); });
  }
  function sync() {
    var host = document.getElementById('ads-agent-host');
    var nextRoot = host && host.shadowRoot;
    if (nextRoot !== root) {
      if (observer) observer.disconnect();
      root = nextRoot;
      if (root) {
        observer = new MutationObserver(schedule);
        observer.observe(root, { childList: true, subtree: true, characterData: true });
      }
    }
    customizeAgentMenu();
    var trigger = launcher();
    var panel = dialog();
    var available = !!(trigger || panel);
    var headerButtons = buttons();
    if (available && headerButtons.length && !root.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = '[data-testid="entrypoint"] { display: none !important; }';
      root.appendChild(style);
    }
    if (!headerButtons.length && root) {
      var oldStyle = root.getElementById(styleId);
      if (oldStyle) oldStyle.remove();
    }
    headerButtons.forEach(function (button) {
      button.disabled = !available;
      button.setAttribute('aria-expanded', panel ? 'true' : 'false');
      var label = available ? button.dataset.labelReady : button.dataset.labelLoading;
      button.setAttribute('aria-label', label);
      button.title = label;
    });
    if (wasOpen && !panel && lastTrigger && document.contains(lastTrigger)) {
      if (document.activeElement === host || document.activeElement === document.body) lastTrigger.focus();
    }
    wasOpen = !!panel;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tototo-ai-trigger]');
    if (!button) return;
    sync();
    lastTrigger = button;
    var panel = dialog();
    if (panel) {
      var input = panel.querySelector('textarea, input, [tabindex="0"], button');
      if (input) input.focus();
    } else {
      var trigger = launcher();
      if (trigger) trigger.click();
    }
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  window.addEventListener('pageshow', schedule);
  var bodyObserver = new MutationObserver(schedule);
  bodyObserver.observe(document.body, { childList: true });
  // A shadow root can attach after its host, without generating a light-DOM mutation.
  var attempts = 0;
  var poll = window.setInterval(function () {
    sync();
    if (launcher() || dialog() || ++attempts >= 150) window.clearInterval(poll);
  }, 200);
  sync();
})();
